import { Box, Typography } from '@mui/material';

interface Props { };

function NoBuamatogForU(props : Props) {
    return (
        <Box sx={{ height: '100%', display: 'grid', placeItems: 'center' }}>
            <Box sx={{ textAlign: 'center' }}>
                <Typography variant={'h1'}>Sorry</Typography>
                <Typography variant={'h6'}>But no Buamatog for u!</Typography>
            </Box>
        </Box>
    );
}

export default NoBuamatogForU;